import { IModel, IAttribute } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { NativeMongoDbDataset } from 'app/model/dataset/native-mongo-db.dataset';
import { ICopySinkWithUpdateMethod, UpdateMethod, UpdateMethodType } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.mongoDb.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(NativeMongoDbDataset) }
})
export class NativeMongoDbApiSink extends CopySink implements ICopySinkWithUpdateMethod {
    public static readonly MODEL: IModel;
    public static readonly WRITE_BEHAVIOR: IAttribute;
    public static readonly WRITE_BATCH_SIZE: IAttribute;
    public static readonly WRITE_BATCH_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_SIZE',
        display: stringResources.ModelName_WriteBatchSize
    })
    public writeBatchSize?: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BATCH_TIMEOUT',
        constraint: {
            pattern: new RegExp('^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$')
        },
        display: stringResources.ModelName_WriteBatchTimeout
    })
    public writeBatchTimeout?: string = '00:30:00';

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior?: string = writeBehaviorOptionValues.insert;

    public get updateMethod(): UpdateMethodType {
        switch (this.writeBehavior) {
            case writeBehaviorOptionValues.insert:
                return UpdateMethod.Append;
            case writeBehaviorOptionValues.upsert:
                return UpdateMethod.Upsert;
            default:
                return undefined;
        }
    }

    public set updateMethod(value: UpdateMethodType) {
        switch (value) {
            case UpdateMethod.Append:
                this.writeBehavior = writeBehaviorOptionValues.insert;
                break;
            case UpdateMethod.Upsert:
                this.writeBehavior = writeBehaviorOptionValues.upsert;
                break;
            default:
        }
    }
}
